module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-5-93d7617be02efac1753a5cbb9273cdcf.svg";